<template>
    <LoadingBar ref="loadingBar" />
    <header
        class="w-full fixed top-0 border-b border-gray-200 dark:border-gray-700 z-10 bg-white dark:bg-black z-[9999]">
        <nav class="px-4 lg:px-0 container mx-auto flex justify-between">
            <div
                class="max-w-screen-xl flex flex-wrap items-center justify-start max-xs:justify-center sm:mx-0 py-4 gap-5 ">
                <router-link to="/fa" class="flex items-center space-x-3 rtl:space-x-reverse hover:opacity-75">
                    <img src="@/assets/images/logo.png" class="w-10" alt="" />
                    <img src="@/assets/images/text-logo.png" class="object-contain w-56 hidden md:block" alt="" />
                </router-link>
                <nav class="hidden xl:flex gap-4">
                    <router-link :to="langPath" :class="navLinkClass('')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
                            <path
                                d="M12 2.0996094L1 12L4 12L4 21L11 21L11 15L13 15L13 21L20 21L20 12L23 12L12 2.0996094 z M 12 4.7910156L18 10.191406L18 11L18 19L15 19L15 13L9 13L9 19L6 19L6 10.191406L12 4.7910156 z"
                                fill="currentColor" />
                        </svg>
                        <span class="mr-2 text-sm font-bold">{{ $t("home") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/library`" :class="navLinkClass('library')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
                            <path
                                d="M2 4L2 18C2 19.105 2.895 20 4 20L10.277344 20C10.623613 20.595634 11.261054 21 12 21C12.738946 21 13.376387 20.595634 13.722656 20L20 20C21.105 20 22 19.105 22 18L22 4L14 4C13.228 4 12.532 4.3002969 12 4.7792969C11.468 4.3002969 10.772 4 10 4L2 4 z M 4 6L10 6C10.551 6 11 6.449 11 7L11 18L4 18L4 6 z M 14 6L20 6L20 18L13 18L13 7C13 6.449 13.449 6 14 6 z"
                                fill="currentColor" />
                        </svg>
                        <span class="mr-2 text-sm font-bold">{{ $t("library") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/posts`" :class="navLinkClass('posts')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
                            <path
                                d="M5 1C3.9 1 3 1.9 3 3L3 17L5 17L5 3L17 3L17 1L5 1 z M 9 5C7.9 5 7 5.9 7 7L7 21C7 22.1 7.9 23 9 23L20 23C21.1 23 22 22.1 22 21L22 7C22 5.895 21.105 5 20 5L9 5 z M 9 7L20 7L20 21L9 21L9 7 z M 11 9L11 11L18 11L18 9L11 9 z M 11 13L11 15L18 15L18 13L11 13 z M 11 17L11 19L18 19L18 17L11 17 z"
                                fill="currentColor" />
                        </svg>
                        <span class="mr-2 text-sm font-bold">{{ $t("posts") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/media`" :class="navLinkClass('media')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
                            <path
                                d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                                fill="currentColor" />
                        </svg>
                        <span class="mr-2 text-sm font-bold">{{ $t("media") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/sound`" :class="navLinkClass('sound')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
                            <path
                                d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                                fill="currentColor" />
                        </svg>
                        <span class="mr-2 text-sm font-bold">{{ $t("sound") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/photo`" :class="navLinkClass('photo')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
                            <path
                                d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                                fill="currentColor" />
                        </svg>
                        <span class="mr-2 text-sm font-bold">{{ $t("photo") }}</span>
                    </router-link>

                    <router-link :to="`${langPath}/aboutus`" :class="navLinkClass('aboutus')">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-6 h-6">
                            <path
                                d="M12 2C6.4889971 2 2 6.4889971 2 12C2 17.511003 6.4889971 22 12 22C17.511003 22 22 17.511003 22 12C22 6.4889971 17.511003 2 12 2 z M 12 4C16.430123 4 20 7.5698774 20 12C20 16.430123 16.430123 20 12 20C7.5698774 20 4 16.430123 4 12C4 7.5698774 7.5698774 4 12 4 z M 11 7L11 9L13 9L13 7L11 7 z M 11 11L11 17L13 17L13 11L11 11 z"
                                fill="currentColor" />
                        </svg>
                        <span class="mr-2 text-sm font-bold">{{ $t("about_us") }}</span>
                    </router-link>
                </nav>
            </div>
            <div class="flex">
                <div class="relative my-auto">
                    <button @click="toggleLangMenu"
                        class="hover:opacity-75 flex items-center text-sm pe-1 font-medium rounded-full md:me-0 gap-2">
                        <span>{{ $t("select_language") }}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-translate w-5 h-5"
                            viewBox="0 0 16 16">
                            <path
                                d="M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z" />
                            <path
                                d="M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31" />
                        </svg>
                    </button>

                    <div v-show="langMenuOpen"
                        class="absolute top-full mt-2 right-0 z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-dim-900 dark:divide-gray-600">
                        <ul class="py-2 text-sm text-gray-700 dark:text-gray-200">
                            <li v-for="item in language" :key="item.id">
                                <a href="#" @click.prevent="setLanguage(item)"
                                    class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-dim-700 dark:hover:text-white">
                                    {{ item.title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="flex gap-2 items-center relative  mr-4" dir="ltr">
                    <!-- <span class="mr-2 text-sm">{{ $t("dark_mode") }}</span> -->
                    <label class="inline-flex items-center cursor-pointer">
                        <input type="checkbox" class="sr-only peer" @change="toggleDarkMode" ref="darkModeCheckbox" />
                        <div
                            class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-greenrefah">
                        </div>
                    </label>
                </div>
            </div>
        </nav>
    </header>

    <div class="mt-[70px] mb-10">
        <router-view v-slot="{ Component, route }">
            <component :is="Component" :key="$i18n.locale + '-' + route.fullPath" />
        </router-view>
    </div>

    <footer class="bg-white rounded-lg shadow dark:bg-black border-t border-gray-200 dark:border-gray-700">
        <div class="w-full max-w-screen-xl mx-auto p-4 md:py-8">
            <div class="sm:flex sm:items-center sm:justify-between">
                <a href="https://binesheno.com/" class="flex items-center mb-4 sm:mb-0 space-x-3 rtl:space-x-reverse">
                    <img src="@/assets/images/logo.png" class="h-8" alt="Flowbite Logo" />
                    <span
                        class="self-center text-sm whitespace-nowrap text-white bg-primary p-2 rounded-tr-lg rounded-bl-lg">
                        {{ $t("footer_institute") }}</span>
                </a>
                <ul
                    class="flex flex-wrap items-center mb-6 text-sm font-medium text-gray-500 sm:mb-0 dark:text-gray-400">
                    <li>
                        <router-link to="/fa/aboutus" class="hover:underline me-4 md:me-6">{{ $t("about_us")
                        }}</router-link>
                    </li>
                </ul>
            </div>
            <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
            <span class="block text-sm sm:text-center">
                © 1404-1405 <router-link :to="langPath" class="hover:underline">{{ $t("footer_institute")
                }}</router-link>.
                {{ $t("footer_rights") }}
            </span>
        </div>
    </footer>
    <button v-if="isVisible" @click="scrollToTop"
        class="text-sm fixed bottom-4 right-4 bg-primary text-white px-3 py-1 rounded-tr-lg rounded-bl-lg shadow-md transition transform hover:scale-110 dark:bg-primary"
        aria-label="Scroll to top"> {{ $t("back_to_top") }}</button>

    <nav
        class="flex xl:hidden gap-4 fixed theme-background border-t bottom-0 right-0 left-0 justify-around p-4 z-[9999]">
        <router-link :to="langPath" :class="navLinkClass('')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
                <path
                    d="M12 2.0996094L1 12L4 12L4 21L11 21L11 15L13 15L13 21L20 21L20 12L23 12L12 2.0996094 z M 12 4.7910156L18 10.191406L18 11L18 19L15 19L15 13L9 13L9 19L6 19L6 10.191406L12 4.7910156 z"
                    fill="currentColor" />
            </svg>
        </router-link>
        <router-link :to="`${langPath}/library`" :class="navLinkClass('library')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
                <path
                    d="M2 4L2 18C2 19.105 2.895 20 4 20L10.277344 20C10.623613 20.595634 11.261054 21 12 21C12.738946 21 13.376387 20.595634 13.722656 20L20 20C21.105 20 22 19.105 22 18L22 4L14 4C13.228 4 12.532 4.3002969 12 4.7792969C11.468 4.3002969 10.772 4 10 4L2 4 z M 4 6L10 6C10.551 6 11 6.449 11 7L11 18L4 18L4 6 z M 14 6L20 6L20 18L13 18L13 7C13 6.449 13.449 6 14 6 z"
                    fill="currentColor" />
            </svg>
        </router-link>
        <router-link :to="`${langPath}/posts`" :class="navLinkClass('posts')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
                <path
                    d="M5 1C3.9 1 3 1.9 3 3L3 17L5 17L5 3L17 3L17 1L5 1 z M 9 5C7.9 5 7 5.9 7 7L7 21C7 22.1 7.9 23 9 23L20 23C21.1 23 22 22.1 22 21L22 7C22 5.895 21.105 5 20 5L9 5 z M 9 7L20 7L20 21L9 21L9 7 z M 11 9L11 11L18 11L18 9L11 9 z M 11 13L11 15L18 15L18 13L11 13 z M 11 17L11 19L18 19L18 17L11 17 z"
                    fill="currentColor" />
            </svg>
        </router-link>
        <router-link :to="`${langPath}/media`" :class="navLinkClass('media')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
                <path
                    d="M7 3C5.895 3 5 3.895 5 5L19 5C19 3.895 18.105 3 17 3L7 3 z M 4 7C2.895 7 2 7.895 2 9L2 19C2 20.105 2.895 21 4 21L20 21C21.105 21 22 20.105 22 19L22 9C22 7.895 21.105 7 20 7L4 7 z M 4 9L20 9L20 19L4 19L4 9 z M 10 11L10 17L15 14L10 11 z"
                    fill="currentColor" />
            </svg>
        </router-link>
        <router-link :to="`${langPath}/aboutus`" :class="navLinkClass('aboutus')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
                <path
                    d="M12 2C6.4889971 2 2 6.4889971 2 12C2 17.511003 6.4889971 22 12 22C17.511003 22 22 17.511003 22 12C22 6.4889971 17.511003 2 12 2 z M 12 4C16.430123 4 20 7.5698774 20 12C20 16.430123 16.430123 20 12 20C7.5698774 20 4 16.430123 4 12C4 7.5698774 7.5698774 4 12 4 z M 11 7L11 9L13 9L13 7L11 7 z M 11 11L11 17L13 17L13 11L11 11 z"
                    fill="currentColor" />
            </svg>
        </router-link>
        <router-link :to="`${langPath}/contactus`" :class="navLinkClass('contactus')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-8 h-8">
                <path
                    d="M12 3C7.593562 3 4 6.593562 4 11L4 12C2.9 12 2 12.9 2 14L2 16C2 17.1 2.9 18 4 18L6 18L6 13L6 12L6 11C6 7.674438 8.674438 5 12 5C15.325562 5 18 7.674438 18 11L18 12L18 13L18 18L18 19L13.912109 19 A 1.5 1.5 0 0 0 12.5 18 A 1.5 1.5 0 0 0 11 19.5 A 1.5 1.5 0 0 0 12.392578 20.994141 A 1.0001 1.0001 0 0 0 12.5 21L18 21C19.093063 21 20 20.093063 20 19L20 18C21.1 18 22 17.1 22 16L22 14C22 12.9 21.1 12 20 12L20 11C20 6.593562 16.406438 3 12 3 z"
                    fill="currentColor" />
            </svg>
        </router-link>
    </nav>
</template>

<script>
import { mapGetters } from "vuex";
import LoadingBar from "@/components/LoadingBar.vue";

export default {
    name: "TheContainer",
    components: { LoadingBar },
    data() {
        return {
            isVisible: false,
            langMenuOpen: false,
        };
    },
    computed: {
        ...mapGetters({ language: "baseX/language" }),
        currentLang() {
            return this.$route.path.split("/")[1] || "fa";
        },

        langPath() {
            return `/${this.currentLang}`;
        },

        basePathWithoutLang() {
            return this.$route.path.replace(/^\/[^/]+/, "");
        },
    },
    watch: {
        $route() {
            this.$refs.loadingBar.startLoading();
            setTimeout(() => this.$refs.loadingBar.stopLoading(), 1000);
        },
    },
    methods: {
        navLinkClass(path) {
            const current = this.$route.path;
            const target = path ? `${this.langPath}/${path}` : this.langPath;
            return {
                "text-primary flex items-center": current === target,
                "text-gray-800 dark:text-white flex items-center": current !== target,
            };
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        handleScroll() {
            this.isVisible = window.scrollY > 300;
        },
        toggleDarkMode(event) {
            const html = document.querySelector("html");
            if (event.target.checked) {
                html.classList.add("dark");
                localStorage.setItem("darkMode", "enabled");
            } else {
                html.classList.remove("dark");
                localStorage.setItem("darkMode", "disabled");
            }
        },
        toggleLangMenu() {
            this.langMenuOpen = !this.langMenuOpen;
        },
        setLanguage(item) {
            const newLang = item.codeKey;

            this.$i18n.locale = newLang;
            localStorage.setItem("languageCode", newLang);
            localStorage.setItem("languageId", item.id);

            const pathAfterLang = this.$route.path.replace(/^\/[^/]+/, "");

            const newPath = `/${newLang}${pathAfterLang || ""}`;

            if (newPath !== this.$route.path) {
                this.$router.replace(newPath).catch(() => { });
            }

            this.langMenuOpen = false;
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
        this.$store.dispatch("baseX/getLanguage");

        const darkMode = localStorage.getItem("darkMode");
        if (darkMode === "enabled") {
            document.querySelector("html").classList.add("dark");
            this.$refs.darkModeCheckbox.checked = true;
        }

        const savedLang = localStorage.getItem("languageCode") || "fa";
        if (this.$i18n.locale !== savedLang) {
            this.$i18n.locale = savedLang;
        }
    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    },
};
</script>

<style scoped>
@media print {
    .noprint {
        display: none !important;
    }
}
</style>
